export enum AttachmentLoadingTypeEnum {
  None = 0,
  FromServer = 1,
  FromDb = 2
}
